import { ComponentStyleConfig } from '@chakra-ui/react';

export const IconButton: ComponentStyleConfig = {
  defaultProps: {
    isRound: true,
  },
};
